import { booleanAttribute, ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";
import { TranslatedString } from 'models/translated-string';

@Component({
    selector: 'cs-item-group',
    templateUrl: 'cs-item-group.html',
    host: { 'class': 'item-group' },
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsItemGroupComponent {
    @Input() title?: TranslatedString;
    @Input({ transform: booleanAttribute }) small: boolean = false;

    @HostBinding('class.small')
    get isSmall() { return this.small; }
}